import { Component, OnInit, OnDestroy } from '@angular/core';
import { RequestService } from 'src/app/services/request.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { takeUntil, take } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SimpleInputDialog } from 'src/app/Modal/simple-input.modal';
import { FileImportDialogComponent } from './file-import-dialog/file-import-dialog.component';
import { ModalDialog } from 'src/app/Modal/modal';
import { Region, RegionWithState } from 'src/app/models/region.model';
import { PublishStateRegion } from 'src/app/models/PublishStateRegion.model';
import { PublishStateEnum } from 'src/app/models/enums/PublishStateEnum';
import { dynamicLocaleCompareWithOptions } from 'src/app/helper/sortFunctions';

@Component({
  selector: 'app-datamanagement-list',
  templateUrl: './datamanagement-list.component.html',
  styleUrls: ['./datamanagement-list.component.scss']
})
export class DatamanagementListComponent implements OnInit, OnDestroy {
  datamanagement = {
    title: 'Datamanagement',
    col1Titel: 'Region name', col2Titel: 'Creation date', col3Titel: 'State', col4Titel: 'Actions'
    , action1: 'Edit region', action2: 'Copy this region as new region', action3: 'Delete region', action4: 'View region', action5: 'Publish', action6: 'Import CSV File', action7: 'Show Region', tab1Titel: 'Region Data', tab2Titel: 'Graphic Data'
  }

  dataSourceBaseData = new MatTableDataSource<RegionWithState>();
  private unscubscribe$ = new Subject<void>();
  displayedColumns: string[];

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private requestService: RequestService
  ) { }

  ngOnInit() {
    this.displayedColumns = ['regionName', 'regionCreation', 'regionState', 'regionActions'];
    this.loadRegions();
    sessionStorage.setItem('fileImport', "");
    sessionStorage.setItem('fileImportDeleteTravelMixes', "");
  }

  loadRegions() {
    this.requestService.getRegionsWithState()
      .pipe(takeUntil(this.unscubscribe$))
      .subscribe(resp => {
        this.setRegionList(resp);
      });
  }

  setRegionList(regionList: RegionWithState[]) {
    if (regionList) {
      this.dataSourceBaseData.data = regionList.sort((a, b) => dynamicLocaleCompareWithOptions(a, b, 'regionName'));
    } else {
      this.dataSourceBaseData.data = [];
    }
  }

  openCopyAsNewRegionDialog(id: number) {
    let dialogRef = this.dialog.open(SimpleInputDialog, {
      data: { title: 'Please enter a region name', layoutname: '' }
    });

    dialogRef.afterClosed().subscribe(data => {
      if (data && data.state && data.layoutname !== '') {
        this.createCopyAsNewRegion(id, data.layoutname);

      } else {
        // do nothing in this case
      }
    });
  }

  createCopyAsNewRegion(id: number, regionName: string) {
    let region = new Region();
    region.id = id;
    region.name = regionName;
    this.requestService.copyRegion(region).pipe(takeUntil(this.unscubscribe$))
      .subscribe((resp: any) => {
        this.setRegionList(resp);
      });
  }

  openEditor(regionId: number) {
    this.router.navigate(['datamanagement/view/', 1, regionId]);
  }

  showRegion(regionId: number) {
    this.router.navigate(['datamanagement/view/', 0, regionId]);
  }

  showDeleteDialog(regionId: number): void {
    let message: string = "Are your sure that you want to delete the Region " + this.dataSourceBaseData.data.filter(f => f.id == regionId)[0].regionName + "?";
    const dialogRef = this.dialog.open(ModalDialog, {
      data: {
        title: 'Warning',
        message: message,
        showCancel: true,
        cancelButtonText: 'Cancel',
        saveButtonText: 'Delete'
      }
    });

    dialogRef.afterClosed()
      .subscribe(result => {
        if (result) {
          let publishStateRegion: PublishStateRegion = new PublishStateRegion();
          publishStateRegion.regionId = regionId;
          publishStateRegion.publishStateId = PublishStateEnum.Deprecated;
          this.requestService.changePublishStateOfRegion(publishStateRegion).pipe(takeUntil(this.unscubscribe$))
            .subscribe((resp: any) => {
              this.setRegionList(resp);
            });
        } else { }
      });
  }

  setAsDefaultRegionDialog(regionId: number) {
    let message: string = "Are your sure that you want to set the region " + this.dataSourceBaseData.data.filter(f => f.id == regionId)[0].regionName + " as new default region?";
    const dialogRef = this.dialog.open(ModalDialog, {
      data: {
        title: 'Warning',
        message: message,
        showCancel: true,
        cancelButtonText: 'Cancel',
        saveButtonText: 'Set as default region'
      }
    });

    dialogRef.afterClosed()
      .subscribe(result => {
        if (result) {
          this.requestService.setAsDefaultRegion(regionId)
            .pipe(takeUntil(this.unscubscribe$))
            .subscribe((resp: any) => {
              this.setRegionList(resp);
            });
        } else { }
      });
  }

  showPublishDialog(regionId: number): void {
    let message: string = "Are your sure that you want to publish the Region " + this.dataSourceBaseData.data.filter(f => f.id == regionId)[0].regionName + "?";
    const dialogRef = this.dialog.open(ModalDialog, {
      data: {
        title: 'Warning',
        message: message,
        showCancel: true,
        cancelButtonText: 'Cancel',
        saveButtonText: 'Publish'
      }
    });

    dialogRef.afterClosed()
      .subscribe(result => {
        if (result) {
          let publishStateRegion: PublishStateRegion = new PublishStateRegion();
          publishStateRegion.regionId = regionId;
          publishStateRegion.publishStateId = PublishStateEnum.Published;
          this.requestService.changePublishStateOfRegion(publishStateRegion).pipe(takeUntil(this.unscubscribe$))
            .subscribe((resp: any) => {
              this.setRegionList(resp);
            });
        } else { }
      });
  }

  openFileImportDialog(regionId: number) {
    const dialogRef = this.dialog.open(FileImportDialogComponent,
      {
        width: '450px',
      });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.save) {
        sessionStorage.setItem('fileImport', result.data.fileContent);
        sessionStorage.setItem('fileImportDeleteTravelMixes', result.data.deleteTravelMixes);
        this.openEditor(regionId);
      }
    })
  }

  openView(regionId: number) {
    this.router.navigate(['datamanagement/view/', regionId]);
  }

  ngOnDestroy(): void {
    this.unscubscribe$.next();
    this.unscubscribe$.complete();
  }
}